module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/deals/deals-grid/deals-grid.component.css
// module id = ./src/app/components/deals/deals-grid/deals-grid.component.css
// module chunks = main